module.exports = __webpack_public_path__ + "img/locking.c97ef44c.svg";